import { MessageSquare, User, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { ThreadListItemDto } from '../../types';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface ThreadCardProps {
  thread: ThreadListItemDto;
  isSelected?: boolean;
  onClick?: () => void;
}

export function ThreadCard({ thread, isSelected, onClick }: ThreadCardProps) {
  const formattedDate = thread.lastMessageAt
    ? format(new Date(thread.lastMessageAt), 'dd/MM/yyyy HH:mm', { locale: ptBR })
    : format(new Date(thread.createdAt), 'dd/MM/yyyy HH:mm', { locale: ptBR });

  return (
    <Card
      className={`cursor-pointer transition-colors hover:bg-muted/50 ${
        isSelected ? 'bg-primary/10 border-primary' : ''
      }`}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          {/* Avatar */}
          <div className="flex-shrink-0">
            <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center">
              <User className="h-6 w-6 text-muted-foreground" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            {/* Header */}
            <div className="flex items-start justify-between gap-2 mb-1">
              <h3 className="font-semibold text-sm truncate">
                {thread.senderName || thread.senderPhone || thread.senderId}
              </h3>
              <span className="text-xs text-muted-foreground whitespace-nowrap">
                <Clock className="h-3 w-3 inline mr-1" />
                {formattedDate}
              </span>
            </div>

            {/* Preview */}
            <p className="text-sm text-muted-foreground line-clamp-2 mb-2">
              {thread.lastMessagePreview || 'Sem mensagens'}
            </p>

            {/* Footer */}
            <div className="flex items-center gap-2 flex-wrap">
              <Badge variant="outline" className="text-xs">
                {thread.channel}
              </Badge>
              <Badge
                variant={thread.status === 'open' ? 'default' : 'secondary'}
                className="text-xs"
              >
                {thread.status}
              </Badge>
              <span className="text-xs text-muted-foreground flex items-center gap-1">
                <MessageSquare className="h-3 w-3" />
                {thread.messageCount}
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
